import type { ReactNode } from "react";
import { SiteHeader } from "@/components/public/site-header";
import { SiteFooter } from "@/components/public/site-footer";
import { HeaderEndSlotProvider } from "@/components/public/header-slot";

/** The one public shell (header, skip link, footer) shared by public pages and the portal. */
export function PublicShell({ children, ground = "bg-background" }: { children: ReactNode; ground?: string }) {
  return (
    <HeaderEndSlotProvider>
      {(endSlot, tone) => (
        <div className={`public-shell flex min-h-dvh flex-col ${ground}`}>
          <SiteHeader endSlot={endSlot} tone={tone} />
          <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:start-3 focus:z-50 focus:rounded-full focus:bg-primary focus:px-4 focus:py-2 focus:font-display focus:text-sm focus:font-bold focus:text-primary-foreground focus:shadow-md"
          >
            الانتقال إلى المحتوى
          </a>
          <main id="main-content" className="flex-1">
            {children}
          </main>
          <SiteFooter />
        </div>
      )}
    </HeaderEndSlotProvider>
  );
}
